<template>
  <div class="validation-compare">
    <a-card title="验证结果对比" size="small">
      <a-row :gutter="16">
        <!-- 左侧：出参定义 -->
        <a-col :span="12">
          <a-typography-title :level="5">出参定义</a-typography-title>
          <pre class="json-display">{{ formattedOutputParams }}</pre>
        </a-col>

        <!-- 右侧：实际响应 -->
        <a-col :span="12">
          <a-typography-title :level="5">实际响应</a-typography-title>
          <pre class="json-display">{{ formattedResponse }}</pre>
        </a-col>
      </a-row>

      <!-- 对比详情 -->
      <div v-if="validationDetails.length > 0" style="margin-top: 16px">
        <a-typography-title :level="5">对比详情</a-typography-title>
        <a-list size="small" :data-source="validationDetails">
          <template #renderItem="{ item }">
            <a-list-item>
              <a-tag :color="getStatusColor(item.status)">
                {{ getStatusText(item.status) }}
              </a-tag>
              <span style="margin-left: 8px">
                <strong>{{ item.field }}</strong>:
                <span v-if="item.status === 'match'">匹配</span>
                <span v-else-if="item.status === 'missing'">缺失</span>
                <span v-else-if="item.status === 'type_mismatch'">
                  类型不匹配 (期望: {{ item.expected_type }}, 实际: {{ item.actual_type }})
                </span>
                <span v-else-if="item.status === 'constraint_violation'">
                  {{ item.message }}
                </span>
              </span>
            </a-list-item>
          </template>
        </a-list>
      </div>
    </a-card>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'ValidationCompare',
  props: {
    validationResult: {
      type: Object,
      required: true
    },
    outputParams: {
      type: Object,
      default: null
    },
    response: {
      type: [Object, String],
      default: null
    }
  },
  setup(props) {
    const formattedOutputParams = computed(() => {
      if (!props.outputParams) return '无出参定义';
      return JSON.stringify(props.outputParams, null, 2);
    });

    const formattedResponse = computed(() => {
      if (!props.response) return '无响应';
      
      if (typeof props.response === 'string') {
        try {
          const parsed = JSON.parse(props.response);
          return JSON.stringify(parsed, null, 2);
        } catch (e) {
          return props.response;
        }
      } else if (typeof props.response === 'object') {
        return JSON.stringify(props.response, null, 2);
      }

      return String(props.response);
    });

    const validationDetails = computed(() => {
      return props.validationResult.validation_details || [];
    });

    const getStatusColor = (status) => {
      const colorMap = {
        match: 'green',
        missing: 'red',
        type_mismatch: 'orange',
        constraint_violation: 'gold'
      };
      return colorMap[status] || 'default';
    };

    const getStatusText = (status) => {
      const textMap = {
        match: '匹配',
        missing: '缺失',
        type_mismatch: '类型不匹配',
        constraint_violation: '约束违反'
      };
      return textMap[status] || status;
    };

    return {
      formattedOutputParams,
      formattedResponse,
      validationDetails,
      getStatusColor,
      getStatusText
    };
  }
};
</script>

<style scoped>
.validation-compare {
  margin-bottom: 16px;
}

.json-display {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-height: 300px;
  overflow-y: auto;
}
</style>

